import type { WidgetConfigOption } from "src/charts/widgetConfig";
import { parseSparklePayload } from "src/components/widgets/SparkleWidget";
import { parseSegments } from "src/components/widgets/GroupedBarWidget";

/**
 * The tabs a widget currently offers, for the builder's "Set Default Tab"
 * submenu.
 *
 * These can't live in charts/widgetConfig.ts because they aren't static:
 * sparkle and grouped_bar derive their tabs from the payload itself, so the
 * only way to list them is to run the same parser the widget runs. They are
 * also the only two widgets with a real tab strip. In the
 * builder the payload is the dummy data (config/dummy/widgets), which is
 * shaped like the real thing — so the author picks from real tab names
 * without needing a live dashboard.
 *
 * Returning [] is normal and means "no tabs to choose from"; the menu hides
 * the item rather than offering an empty submenu.
 */
export function getWidgetTabOptions(
  chartType: string,
  data: unknown,
): WidgetConfigOption[] {
  if (chartType === "sparkle") {
    return parseSparklePayload(data).segments.map((segment) => ({
      value: segment.key,
      label: segment.label,
    }));
  }

  if (chartType === "grouped_bar") {
    return parseSegments(data).map((segment) => ({
      value: segment.key,
      label: segment.label,
    }));
  }

  return [];
}
